import { describeLoadError } from '@/lib/load-error';
import { Alert, AlertAction, AlertDescription, AlertTitle, Button } from '@mgrvtechgroup/admin-ds';
import { CircleAlertIcon } from 'lucide-react';

/**
 * 조회 실패 안내 — 오류는 빈 상태가 아니라 Alert로 알린다(DS C10).
 * 다시 시도해도 소용없는 실패(권한·없는 대상)에는 버튼을 내지 않는다.
 */
export function LoadFailure({
  error,
  subject,
  onRetry,
  className,
}: {
  error: unknown;
  subject: string;
  onRetry?: () => void;
  className?: string;
}) {
  const { title, description, retryable } = describeLoadError(error, subject);
  return (
    <Alert variant="destructive" icon={CircleAlertIcon} className={className}>
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
      {onRetry && retryable && (
        <AlertAction>
          <Button size="xs" variant="outline" onClick={onRetry}>
            다시 시도
          </Button>
        </AlertAction>
      )}
    </Alert>
  );
}
